<template>
  <b-card>
    <FormView
      :data="$store.getters['settings/detailData']"
      :fields="$store.getters['settings/tableFields']"
      @load="loadData"
    />
  </b-card>
</template>

<script>
import FormView from '@/layouts/components/FormView.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    FormView,
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('settings/getDetail', id)
    },
  },
}
</script>

<style scoped>

</style>
